import './StatisticsCard.scss'

const StatisticsCard = ({ title, iconClasses, statistic, description }) => {
  return (
    <div className='statistics-card'>
      <div className='statistics-card-header'>
        <p>{title}</p>
        <i className={iconClasses}></i>
      </div>
      <div className='statistics-card-content'>
        <h4>{statistic}</h4>
        {description && <p>{description}</p>}
      </div>
    </div>
  )
}

export default StatisticsCard
